<app-navbar></app-navbar>

<div class="affaire-container" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
    class="spinner">
  </mat-progress-spinner>
</div>

<div class="affaire-container" *ngIf="!isLoading">
  <button mat-button class="backButton" (click)="backToAffairs(currentAffair.unitNumber)">
    <mat-icon>arrow_back</mat-icon>
    Retour aux affaires du lot {{ currentAffair.unitNumber }}
  </button>
  <mat-tab-group>
    <mat-tab label="Informations générales">
      <div class="tab-content grid-info">
        <div class="info-block">
          <div class="icon-label">
            <mat-icon>confirmation_number</mat-icon>
            <label>Réf ML</label>
          </div>
          <p>{{ currentAffair.mlRef }}</p>
        </div>

        <div class="info-block">
          <div class="icon-label">
            <mat-icon>location_on</mat-icon>
            <label>Adresse chantier</label>
          </div>
          <p>{{ currentAffair.workSiteFullAddress ?? "N/A" }}</p>
        </div>

        <div class="info-block">
          <div class="icon-label">
            <mat-icon>person</mat-icon>
            <label>Client final</label>
          </div>
          <p>{{ currentAffair.finalCustomerLastname }} {{ currentAffair.finalCustomerFirstname ?? "" }}</p>
        </div>

        <div class="info-block">
          <div class="icon-label">
            <mat-icon>receipt</mat-icon>
            <label>Réf client</label>
          </div>
          <p>{{ currentAffair.customerRef ?? "N/A" }}</p>
        </div>

        <div class="info-block">
          <div class="icon-label">
            <mat-icon>update</mat-icon>
            <label>Dernière mise à jour</label>
          </div>
          <p>{{ currentAffair.updatedAtFormatted }}</p>
        </div>
      </div>
      <div class="tab-content">
        <div class="commande-container">
          <!--<div class="commande-nav">
            <a (click)="currentCommandTab = 0" [ngClass]="{ 'active': currentCommandTab === 0 }">Nouvelle Commande</a>
            <a (click)="currentCommandTab = 1" [ngClass]="{ 'active': currentCommandTab === 1 }">Mes Commandes</a>
            <a (click)="currentCommandTab = 2" [ngClass]="{ 'active': currentCommandTab === 2 }">Paramètres</a>
          </div>-->

          <div *ngIf="currentCommandTab === 0" class="commande-form">
            <h2>Formulaire d'appel sur décision</h2>

            <form [formGroup]="appealForm" (ngSubmit)="sendNewCommandForm()">

              <div class="form-group">
                <label for="lastname">Nom</label>
                <input id="lastname" type="text" formControlName="lastname" placeholder="Nom" class="form-control">
              </div>

              <div class="form-group">
                <label for="firstname">Prénom</label>
                <input id="firstname" type="text" formControlName="firstname" placeholder="Prénom" class="form-control">
              </div>

              <div class="form-group">
                <label>Choisissez une option :</label><br>
                <div>
                  <input type="radio" id="option1" value="call" formControlName="callType">
                  <label for="option1">Appel</label>
                </div>
                <div>
                  <input type="radio" id="option2" value="claim" formControlName="callType">
                  <label for="option2">Réclamation</label>
                </div>
              </div>

              <div class="form-group">
                <label for="comment">Commentaires</label>
                <textarea id="comment" formControlName="comment" placeholder="Détails..." class="form-control"></textarea>
              </div>

              <button type="submit" class="submit-btn">Envoyer</button>

            </form>

          </div>
          <div *ngIf="currentCommandTab === 1">
            <h2>Mes Commandes</h2>
          </div>

          <div *ngIf="currentCommandTab === 2">
            <h2>Paramètres Commandes</h2>
          </div>
        </div>
      </div>


    </mat-tab>

    <mat-tab label="Détails interventions">
      <div class="tab-content">
        <h3>Détails des interventions</h3>
        <p *ngIf="currentAffair.affairProducts.length === 0">Aucune intervention éffectuée.</p>
        <div *ngFor="let affairProduct of currentAffair.affairProducts" class="product-card">
          <div class="colorBorder" [style.background-color]="affairProduct.productStatus.color"></div>
          <p><strong>Produit :</strong> {{ affairProduct.product.name }}</p>
          <p><strong>Statut :</strong> {{ affairProduct.productStatus.name }}</p>
          <div *ngFor="let technician of affairProduct.technicians" class="tech-info">
            <p>
              <strong>Technicien :</strong> {{ technician.fullName }}
              <span class="badge" [style.background]="technician.color">{{ technician.initials }}</span>
            </p>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Documents délivrés">
      <div class="tab-content">
        <h3>Documents délivrés</h3>
        <p *ngIf="currentAffair.affairsDocumentsDelivered?.length === 0">Aucun document délivré.</p>
        <div *ngFor="let document of currentAffair.affairsDocumentsDelivered" class="doc-card">
          <p><strong>Nom document :</strong> {{ document.documentDeliveredName }}</p>
          <p><strong>Produit lié :</strong> {{ document.productName }}</p>
          <button (click)="downloadDocument(document)">Télécharger {{ getFileExtension(document.path).toUpperCase() }}</button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
